import * as React from "react";
import * as ReactDOM from "react-dom";
import ApplicationForm from "../application/applicationform"


(window as any).InitForm = (applicationCms: object, isLandingPage: boolean, isSamleLaan: boolean, bulletPoints: object, mobileBulletPoints: object, isFaqPage: boolean, stepOneImage: object, stepOneText: object, stepTwoImage: object, stepTwoText: object, stepThreeImage: object, stepThreeText: object, faqs: object[]) => {
    const applicationFormElements = document.getElementsByTagName("application-form");
    if (applicationFormElements.length > 0) {
        const element = applicationFormElements[0];

        ReactDOM.render(
            <ApplicationForm applicationCms={applicationCms} isLandingPage={false} bulletPoints={bulletPoints} mobileBulletPoints={mobileBulletPoints} isFaqPage={isFaqPage} stepOneImage stepOneText stepTwoImage stepTwoText stepThreeImage stepThreeText faqs={faqs} />,
            element
        );
    }
}